import { baseUrl } from '@/config';

export default {
  /**
   * View 모드
   */
  VIEW_MODE: {
    MONITORING: 'monitoring', // 모니터링
    EDIT: 'edit', // 편집
    SLIDESHOW: 'slideshow', // 슬라이드쇼
    TREE_EDIT: 'tree_edit', // 트리 편집
  },
  /**
   * 인터렉션 타입
   */
  INTERACTION: {
    MONITORING: 'monitoring', // 모니터링 (기본)
    NO_ACTION: 'no-action', // 사용자액션 제한
    EDIT_MOVE: 'edit-move', // 편집 (이동)
    EDIT_SELECTION: 'edit-selection', // 편집 (영역선택)
    EDIT_LINE: 'edit-line', // 편집 (선 연결)
  },
  /**
   * 사용자 이미지 경로
   */
  IMAGE_PATH: `${baseUrl}/images/custom/`,
  /**
   * 오브젝트 추가 모드
   */
  ATTACH_MODE: {
    ADD: 'add', // 추가
    REPLACE: 'replace', // 교체
    CONNECT: 'connect', // 연결
  },
  /**
   * 오브젝트 타입
   */
  ELEMENT_TYPE: {
    MANAGED: 'managed', // 관리객체
    VIRTUAL: 'virtual', // 가상객체
    IMAGE: 'image', // 사용자이미지
    SUBMAP: 'submap', // 하위맵
    SHAPE: 'shape', // 장식도구
    CUSTOM: 'custom', // 사용자정의위젯
  },
  /**
   * 팝업창 타입
   */
  POPUP_TYPE: {
    MODAL: 'modal', // 모달O
    WINDOW: 'window', // 모달X
  },
  /**
   * 편집 이력 타입
   */
  HISTORY_TYPE: {
    ADD: 'add', // 추가
    REPLACE: 'replace', // 교체
    REMOVE: 'remove', // 삭제
    LOCATION: 'location', // 이동
    SIZE: 'size', // 리사이징
    ALIGN: 'align', // 정렬
    PROPERTY: 'property', // 속성
  },
  /**
   * 툴팁 딜레이
   */
  TOOLTIP_DELAY: 300,
  /**
   * 이벤트버스 종류
   */
  MAP_EVENTBUS: {
    TREE_LOAD: 'tree_load', // 맵 트리 로드
    TREE_SELECT_NODE: 'tree_select_node',
    IMAGE_LOAD: 'image_load', // 사용자  이미지 로드
    ADD_ELEMENT_COMPLETE: 'add_element_complete', // addElement 완료
    REMOVE_ELEMENT_COMPLETE: 'remove_element_complete', // removeElement 완료
    DEVICE_CONTROL: 'device_control',
    CHANGE_MAP_NAME: 'change_map_name', // 맵 이름 변경
    REFRESH_TIMER: 'refresh-timer',
    MAJOR_INFO: 'major_info_open',
    AUTOMAP_MAJOR_INFO: 'automap_major_info_open',
    CONNECT_DEVICE_INFO: 'connect_device_info', // 연결장비 정보
    MAP_DOWNLOAD: 'map_download', // 연결장비 정보
    AUTOMAP_DEVICE_HIGHLIGHT: 'autumap_device_highlight',
    AUTOMAP_DEVICE_VISIBLE: 'autumap_device_visible',
  },
  /**
   * 편집 컨텍스트 메뉴 타입
   * @type {Object}
   */
  CONTEXT_EDIT: {
    PROPERTY: 'property', // 속성
    SEND_TO_TOP: 'sendToTop', // 맨 앞으로 이동
    SEND_TO_BOTTOM: 'sendToBottom', // 맨 뒤로 이동
    COPY: 'copy', // 복사
    PASTE: 'paste', // 붙여넣기
    LAN: 'lan', // 선연결
    POINT: 'point', // 꺾은점
  },
  /**
   * 모니터링 컨텍스투 메뉴 타입
   * @type {Object}
   */
  CONTEXT_MONITORING: {
    APP: 'app', // 관리도구
    MAP: 'map', // 맵 이동
  },
  /**
   * 글꼴 종류
   * @type {Array}
   */
  FONT_FAMILIES: [
    {
      value: '굴림',
      label: '굴림',
    },
    {
      value: '돋움',
      label: '돋움',
    },
    {
      value: 'arial',
      label: 'arial',
    },
    {
      value: '나눔고딕',
      label: '나눔고딕',
    },
  ],
  /**
   * 이미지 타입
   * @type {Array}
   */
  IMAGE_TYPES: [
    {
      value: 'flat',
      label: 'FLAT',
    },
    {
      value: '3d',
      label: '3D',
    },
    {
      value: 'widget',
      label: '위젯',
    },
  ],
  /**
   * 라벨 위치
   * @type {Object}
   */
  LABEL_POSITION: {
    CB: '가운데 아래',
    RB: '오른쪽 아래',
    RM: '오른쪽 가운데',
    RT: '오른쪽 위',
    CT: '가운데 위',
    LT: '왼쪽 위',
    LM: '왼쪽 가운데',
    LB: '왼쪽 아래',
  },
  EVENT_TYPE: {
    STATUS: 'status',
    PREDICT: 'predict',
  },
  /**
   * 범례 및 도움말
   */
  HELP: {
    MENU_TITLE_AT_MONITORING: '사용자 액션',
    MENU_TITLE_AT_EDIT: '편집 단축키',
  },
  LAYOUT_TYPE: {
    CUSTOM: 'custom',
    RADIAL: 'radial',
    CIRCLE: 'circle',
    TREE: 'tree',
    HIERARCHIC: 'hierarchic',
  },
};



// WEBPACK FOOTER //
// ./src/constants/topologymap.js